// extracted by mini-css-extract-plugin
export default {"form":"CreateGroupModal_form__inKN6"};